import * as types from "../actions/project.actions";

const INITIAL_STATE = {
  data: {},
  projects: [],
  projects_csv: [],
  candidates: [],
  matches: [],
  pitches: [],
  statements: [],
  hired: [],
  sortedBy: "date_pitched",
  match: {},
  pitch: {},
  sow: {},
  member: {},
  messages: [],
  loadingMessageAttachment: false,
  loadingGetProjects: false,
  status: [],
  reviewQuestionsForMembers: [],
  reviewQuestionsForEmployer: [],
  adminProjectsOverview: [],
  canSendFeedback: null,
  isSubmitting: false
};

function updateUserData(candidates, data) {
  const index = candidates.findIndex(candidate => candidate.id === data.id);

  return candidates.slice(0, index).concat(
    [
      {
        ...data
      }
    ],
    candidates.slice(index + 1)
  );
}

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.CREATE_PROJECT_START:
      return { ...state };

    case types.CREATE_PROJECT_SUCCESS:
      return { ...state, data: action.data };

    case types.CREATE_PROJECT_ERROR:
      return { ...state };

    case types.UPDATE_PROJECT_START:
      return { ...state, isSubmitting: true };

    case types.UPDATE_PROJECT_SUCCESS:
      return { ...state, data: action.data, isSubmitting: false };

    case types.UPDATE_PROJECT_ERROR:
      return { ...state, isSubmitting: false };

    case types.HIDE_PROJECT_START:
      return { ...state, isSubmitting: true };

    case types.HIDE_PROJECT_SUCCESS:
      return { ...state, data: action.data, isSubmitting: false };

    case types.HIDE_PROJECT_ERROR:
      return { ...state, isSubmitting: false };

    case types.GET_PROJECT_START:
      return { ...state };

    case types.GET_PROJECT_SUCCESS:
      return { ...state, data: action };

    case types.GET_PROJECT_ERROR:
      return { ...state };

    case types.GET_PROJECT_NULL:
      return { ...state, data: {} };

    case types.DECLINE_CANDIDATE_SUCCESS:
      return {
        ...state,
        candidates: updateUserData(state.candidates, action.data)
      };

    case types.SET_SORTED_BY:
      return { ...state, sortedBy: action.sortBy };

    case types.SET_HIRED:
      return { ...state, hired: action.data };

    case types.SET_CANDIDATES:
      return { ...state, candidates: action.candidates };

    case types.SET_MATCHES:
      return { ...state, matches: action.data };

    case types.SET_PITCHES:
      return { ...state, pitches: action.data };

    case types.SET_STATEMENTS:
      return { ...state, statements: action.data };

    case types.SET_MATCH:
      return { ...state, match: action.match };

    case types.SET_PITCH:
      return { ...state, pitch: action.pitch };

    case types.SET_SOW:
      return { ...state, sow: action.sow };

    case types.SET_MEMBER:
      return { ...state, member: action.member };

    case types.SET_MESSAGES:
      return { ...state, messages: action.messages };

    case types.SET_LOADING_MESSAGE_ATTACHMENT:
      return { ...state, loadingMessageAttachment: action.loading };

    case types.GET_PROJECTS_START:
      return { ...state, loadingGetProjects: true };

    case types.GET_PROJECTS_SUCCESS:
      return { ...state, projects: action.projects, loadingGetProjects: false };

    case types.GET_PROJECTS_CSV_SUCCESS:
      return {
        ...state,
        projects_csv: action.projects,
        loadingGetProjects: false
      };

    case types.GET_PROJECTS_ERROR:
      return { ...state, loadingGetProjects: false };

    case types.GET_STATUS_SUCCESS:
      return { ...state, status: action.status.data };

    case types.SET_REVIEW_QUESTIONS_FOR_MEMBER:
      return { ...state, reviewQuestionsForMembers: action.data };

    case types.SET_REVIEW_QUESTIONS_FOR_EMPLOYER:
      return { ...state, reviewQuestionsForEmployer: action.data };

    case types.GET_ADMIN_PROJECTS_OVERVIEW_START:
      return { ...state, loadingGetProjects: true };

    case types.GET_ADMIN_PROJECTS_OVERVIEW_SUCCESS:
      return {
        ...state,
        adminProjectsOverview: action.projects,
        loadingGetProjects: false
      };

    case types.GET_ADMIN_PROJECTS_OVERVIEW_ERROR:
      return { ...state, loadingGetProjects: false };

    case types.ADMIN_UPDATE_PROJECT_SUCCESS:
      return { ...state, data: action.data };

    case types.SET_CAN_SEND_FEEDBACK:
      return { ...state, canSendFeedback: action.data };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project.reducer.js